import { useQuery } from 'providers/tanstack-query/useQuery'
import { fromDTO } from './api/mapper'
import { GET_VIEWPORTS } from './api/query'

import type { Data, Variables, ViewportSliceDTO } from './api/types'
import type { Props, UseGetViewports, ViewportSlice } from './types'

export const useGetViewports = ({ sort, workspaceId }: Props): UseGetViewports => {
  const { data, isLoading } = useQuery<Variables, Data, ViewportSlice[]>({
    options: {
      select: ({ viewports: { nodes } }: Data): ViewportSlice[] =>
        nodes?.map((node: ViewportSliceDTO): ViewportSlice => fromDTO(node)) ?? [],
    },
    query: GET_VIEWPORTS,
    variables: {
      sort,
      workspaceId,
    },
  })

  return {
    loading: isLoading,
    viewports: data,
  }
}
